/**
 *
 * Asynchronously loads the component for Onboarding
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
